export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.5 0C8.58 0 .5 8.08.5 18s8.08 18 18 18 18-8.08 18-18-8.08-18-18-18zm0 32c-7.72 0-14-6.28-14-14s6.28-14 14-14 14 6.28 14 14-6.28 14-14 14zm0-4a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-6-14.5c0-3.04 2.7-5.5 6-5.5s6 2.46 6 5.5c0 2.22-1.32 3.54-2.38 4.58-1.06 1.06-1.62 1.66-1.62 2.92h-4c0-2.96 1.599-4.559 2.777-5.737l.023-.023c.88-.86 1.2-1.22 1.2-1.74 0-.82-.92-1.5-2-1.5s-2 .68-2 1.5h-4z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "37",
    "height": "36",
    "viewBox": "0 0 37 36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};